import baseDataProvider from '../supabase/baseDataProvider'

const centersDataProvider = {
  ...baseDataProvider,
  getList: async (resource, params) => {
    const { meta } = params

    resource = meta?.useView ? 'centers_view' : 'centers'

    return baseDataProvider.getList(resource, params)
  }
}

export const dataProvider = centersDataProvider